import Icon from '@vfz/ui/dist/components/icon/icon';
import { HideOnMobile } from 'components/HideOnMobile';
import React from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './payment-header.content';
import * as S from './payment-header.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentHeader' });

export const PaymentHeader = () => {
  return (
    <S.Header>
      <S.LinkPaymentOverview to="/facturen">
        <Icon name="arrowLeft" width={20} height={20} />
        <HideOnMobile> {contentUtil.translateToString('paymentOverview')}</HideOnMobile>
      </S.LinkPaymentOverview>
      <S.Logo width="130" height="28" />
      <S.SecureConnection>
        <Icon name="lockLocked" variant="solid" width={20} height={20} />
        <HideOnMobile> {contentUtil.translateToString('secureConnection')}</HideOnMobile>
      </S.SecureConnection>
    </S.Header>
  );
};
